import {Route, Outlet} from 'react-router-dom'
import {EmpresasPage} from "@components/empresas/pages/EmpresasPage.tsx";
import {_empresa_sitemap} from "@components/empresas/endpoints/__empresa_endpoints.ts";
import {EmpresaPage} from "@components/empresas/pages/EmpresaPage.tsx";

export const EmpresasRoutes = () => {
    const {empresas} = _empresa_sitemap

    return (<Route
        path={empresas.url}
        element={<Outlet/>}
        children={[
            <Route path={empresas.children.menu.url} index  key={empresas.children.menu.fullUrl} element={<EmpresasPage/>}/>,
            <Route path={empresas.children.detalhes.url} key={empresas.children.detalhes.fullUrl}
                   element={<EmpresaPage/>}/>,
        ]}/>)
};